export const SHIFT_QUESTION_BATCH_LIST = 'SHIFT_QUESTION_BATCH_LIST';
export const SHIFT_QUESTION_BATCH_LIST_SUCCESS = 'SHIFT_QUESTION_BATCH_LIST_SUCCESS';
export const SHIFT_QUESTION_BATCH_LIST_ERROR = 'SHIFT_QUESTION_BATCH_LIST_ERROR';

export const ADD_BATCH = 'ADD_BATCH';
export const ADD_BATCH_SUCCESS = 'ADD_BATCH_SUCCESS';
export const ADD_BATCH_ERROR = 'ADD_BATCH_ERROR';

export const EDIT_BATCH = 'EDIT_BATCH';
export const EDIT_BATCH_SUCCESS = 'EDIT_BATCH_SUCCESS';
export const EDIT_BATCH_ERROR = 'EDIT_BATCH_ERROR';

export const BATCH_DETAILS = 'BATCH_DETAILS';
export const BATCH_DETAILS_SUCCESS =  'BATCH_DETAILS_SUCCESS';
export const BATCH_DETAILS_ERROR = 'BATCH_DETAILS_ERROR';

export const DELETE_BATCH = 'DELETE_BATCH';
export const DELETE_BATCH_SUCCESS = 'DELETE_BATCH_SUCCESS';
export const DELETE_BATCH_ERROR  = 'DELETE_BATCH_ERROR';

export const ADD_QUESTION = 'ADD_QUESTION';
export const ADD_QUESTION_SUCCESS = 'ADD_QUESTION_SUCCESS';
export const ADD_QUESTION_ERROR = 'ADD_QUESTION_ERROR';

export const QUESTION_LIST = 'QUESTION_LIST';
export const QUESTION_LIST_SUCCESS = 'QUESTION_LIST_SUCCESS';
export const QUESTION_LIST_ERROR = 'QUESTION_LIST_ERROR';

export const QUESTION_DETAILS = 'QUESTION_DETAILS';
export const QUESTION_DETAILS_SUCCESS = 'QUESTION_DETAILS_SUCCESS';
export const QUESTION_DETAILS_ERROR = 'QUESTION_DETAILS_ERROR';

export const DELETE_QUESTION = 'DELETE_QUESTION';
export const DELETE_QUESTION_SUCCESS = 'DELETE_QUESTION_SUCCESS';
export const DELETE_QUESTION_ERROR = 'DELETE_QUESTION_ERROR';


